import { plural } from '@cian/utils';

export const getPlatformsText = (platforms: string[]) => {
  if (platforms.length) {
    return `${platforms.length} ${plural(platforms.length, ['площадку', 'площадки', 'площадок'])}`;
  }

  return '';
};
